//#region src/vitrine_cover_block_type.ts
var VitrineCoverBlockType = /* @__PURE__ */ function(VitrineCoverBlockType) {
	VitrineCoverBlockType["CoverImageLarge"] = "cover_image_large";
	VitrineCoverBlockType["CoverImageMedium"] = "cover_image_medium";
	VitrineCoverBlockType["CoverImageSmall"] = "cover_image_small";
	VitrineCoverBlockType["CoverImageExtraSmall"] = "cover_image_extra_small";
	VitrineCoverBlockType["CoverVideoLarge"] = "cover_video_large";
	VitrineCoverBlockType["CoverVideoMedium"] = "cover_video_medium";
	VitrineCoverBlockType["CoverVideoSmall"] = "cover_video_small";
	VitrineCoverBlockType["CoverVideoExtraSmall"] = "cover_video_extra_small";
	VitrineCoverBlockType["PromoRegular"] = "promo_regular";
	VitrineCoverBlockType["PromoMedium"] = "promo_medium";
	VitrineCoverBlockType["PromoSmall"] = "promo_small";
	VitrineCoverBlockType["BottomSection"] = "bottom_section";
	VitrineCoverBlockType["Pathway"] = "pathway";
	return VitrineCoverBlockType;
}(VitrineCoverBlockType || {});
//#endregion
export { VitrineCoverBlockType };

//# sourceMappingURL=vitrine_cover_block_type.js.map